/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Paper,
  TextField,
  Stack,
  Grid,
  Button,
  tableCellClasses,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

import TbBookingStatusForTabThree from "./TbBookingStatusForTabThree";
import OwnDatePickerForTabThree from "./OwnDatePickerForTabThree";
import { useSelector, useDispatch } from "react-redux";
import { fetchLockDateInfos } from "../store/PgBookDateSlice";

/*------------------- Style --------------------------*/
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#FFF",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  //textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "THSarabunNew",
      fontSize: 14,
    },
  },

  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          backgroundColor: grey["200"],
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          [`&.${tableCellClasses.head}`]: {
            fontSize: 12,
          },
          [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
          },
        },
      },
    },
  },
});

/*------------------------------ ContentTapThree -------------------------------------*/
function ContentTapThree(props) {
  const [newdate, setNewDate] = useState(props.date);
  const updateddate = useMemo(() => newdate, [newdate]);

  const [activity, setActivity] = useState("");
  const [lockdateactive, setLockDateActive] = useState([false, false, false]);
  /*------------------- Redux ------------------------*/
  const lockdateinfosdispatch = useDispatch();
  useEffect(() => {
    lockdateinfosdispatch(fetchLockDateInfos(updateddate));
  }, [
    lockdateinfosdispatch,
    updateddate,
    JSON.stringify(lockdateactive),
    activity,
  ]);
  const lockdate = useSelector((state) => state.bookdate.datelocking); //---> moved here on

  /*------------------ added on 12-10-2024 -----------------------*/
  const [lockdateinfos, setLockDateInfos] = useState();

  useEffect(() => {
    setLockDateInfos(lockdate.data);
  }, [lockdate?.data]);

  /*----------------------------------- Return --------------------------*/
  return (
    <ThemeProvider theme={theme}>
      <Stack spacing={4} sx={{ padding: 4 }}>
        <Item>
          <Stack direction={"row"} spacing={2}>
            <Item>
              <Grid container spacing={1}>
                <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                  <Item elevation={0} sx={{ fontWeight: "bold" }}>
                    เลือกวันและเวลา
                  </Item>
                </Grid>
                <Grid item xs={3} display={"flex"} justifyContent={"flex-end"}>
                  <Item elevation={0} sx={{ fontWeight: "bold" }}>
                    กิจกรรม :{" "}
                  </Item>
                </Grid>
                <Grid item xs={9}>
                  <Item elevation={0}>
                    <TextField
                      sx={{ width: "200px" }}
                      //value={activity}
                      onChange={(e) => {
                        setActivity(e.target.value);
                      }}
                    />
                  </Item>
                </Grid>
                <Grid item xs={3} display={"flex"} justifyContent={"flex-end"}>
                  <Item elevation={0} sx={{ fontWeight: "bold" }}>
                    วันที่ :{" "}
                  </Item>
                </Grid>
                <Grid item xs={9}>
                  <Item elevation={0}>
                    <OwnDatePickerForTabThree
                      date={props.date}
                      onDateChange={setNewDate}
                    />
                  </Item>
                </Grid>
                <Grid item xs={12}>
                  <Item elevation={0}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              align="center"
                              colSpan={5}
                              sx={{ fontWeight: "bold" }}
                            >
                              ตารางแสดงสถานะการล็อกวัน
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              align="center"
                              sx={{ fontWeight: "bold" }}
                            >
                              ช่วงเวลา
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ fontWeight: "bold" }}
                            >
                              ชื่อกิจกรรม
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {[
                            "09:00 - 10:00",
                            "10:30 - 11:30",
                            "13:30 - 14:30",
                          ].map((t, i) => {
                            let tmp = lockdateinfos?.filter((ld) => {
                              //lockdate?.data?.filter(ld => {
                              return t.includes(
                                ld.testreqtime.substring(
                                  0,
                                  ld.testreqtime.lastIndexOf(":")
                                )
                              );
                            });

                            tmp = lockdateactive[i] ? tmp : [];
                            return (
                              <TableRow key={i}>
                                <TableCell align="center" key={i + 1}>
                                  {t}
                                </TableCell>
                                <TableCell align="center" key={i + 2}>
                                  {tmp.length !== 0
                                    ? tmp[0]["testappvresult"]
                                    : "--"}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Item>
                </Grid>
              </Grid>
            </Item>
            <Item>
              <TbBookingStatusForTabThree
                date={updateddate /*newdate*/}
                activity={activity}
                setLockDateActive={setLockDateActive}
                setLockDateInfos={setLockDateInfos}
              />
            </Item>
          </Stack>
        </Item>
        <Item sx={{ textAlign: "center" }}>
          <Button
            variant="contained"
            onClick={() => {
              props.tabclosefunc(); //func in pagebookdate.jsx
            }}
          >
            ย้อนกลับ
          </Button>
        </Item>
      </Stack>
    </ThemeProvider>
  );
}

export default ContentTapThree;
